Controller = App.loadClass 'core::Angular/Controller'

class exports.SidebarController extends Controller

    constructor: (@scope, @transitions, @state, FilterService, @changes, @window) ->
        super(@scope, @transitions)
        @scope.service = FilterService
        @scope.service.filter_url = 'backend/portal/key-fields-define/filters'
        @scope.service.beforeApply = @beforeApply
        @scope.service.setDefinitions @defineFilterLayout()

        # Define Searching location functionality
        @geocoder = App.load 'core::Geocoder'
        @scope.search = @search

        # Define Filter functionality
        @setListeners()

        # If we have loaded the keyfields-define sidebar go ahead and load the report
        if @state.current.name is 'portal.keyfields_define'
            @state.go '.report', @state.params,
                location: false


    ###
    Broadcast listeners
    ###
    setListeners: () =>
        # Listens for when a messages needs to be displayed
        @scope.$on 'KeyFieldDefine:displayMessage', (dt, jsn_status) =>
            if jsn_status.msg? and jsn_status.type?
                @scope.setAlert(jsn_status)


    search: (address) =>
        @geocoder.geocode(address)


    beforeApply: () =>
        if @changes.changesMade()
            return @window.confirm('You have unsaved changes.\n\nAre you sure you want to leave this page?')

        return true


    defineFilterLayout: () =>
        return [
            name: 'Region Filters',
            filters: [
                name: 'years'
                display_name: 'Year'
                control_type: 'single_dropdown'
                deletable: false
                selected_values: [
                    { key: moment().year(), value: moment().year() }
                ]
            ,
                name: 'states'
                display_name: 'State'
            ,
                name: 'zones'
                display_name: 'Zone'
            ,
                name: 'counties'
                display_name: 'County'
            ,
                name: 'zips'
                display_name: 'ZIP Code'
            ]
        ,
            name: 'Operation Filters',
            filters: [
                name: 'companies'
                display_name: 'Company'
            ,
                name: 'owners'
                display_name: 'User'
            ,
                name: 'farms'
                display_name: 'Farm'
            ,
                name: 'fields'
                display_name: 'Field'
            ]
        ,
            name: 'Key Fields',
            filters: [
                name: 'seed_rep'
                display_name: 'Seed Rep'
            ,
                name: 'date_planted'
                display_name: 'Date Planted'
                control_type: 'date_range'
                years_filter: 'years'
                options:
                    drops: 'up'
                format: 'MM/DD'
            ,
                name: 'maturity'
                display_name: 'Mat %'
                control_type: 'range'
            ,
                name: 'seed_company'
                display_name: 'Seed Company'
                control_type: 'single_dropdown'
            ,
                name: 'brands'
                display_name: 'Brand'
            ,
                name: 'status'
                display_name: 'Status'
                control_type: 'single_dropdown'
            ]
        ]
